import { render, staticRenderFns } from "./ScreeningDepartmentViewingComponent.vue?vue&type=template&id=4325b1c9&scoped=true&"
import script from "./ScreeningDepartmentViewingComponent.vue?vue&type=script&lang=js&"
export * from "./ScreeningDepartmentViewingComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningDepartmentViewingComponent.vue?vue&type=style&index=0&id=4325b1c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325b1c9",
  null
  
)

export default component.exports